<template>
  <GridBase gak-common class="gak-chuncheon">
    <section class="top">
      <h1>
        <p><q>GAK</q><br /><q>CHUNCHEON</q></p>
      </h1>
    </section>
    <section class="s1 j">
      <PrSplit class="v1" type="type0" img="/img/dc/chuncheon/bg-s1.jpg">
        <div class="title">
          <TextBlock file="dc/chuncheon-data-t1" class="pre-line q j" data-offset="100"/>
        </div>
      </PrSplit>
      <TextBlock
        file="dc/chuncheon-data-t1-1"
        class="pre-line q j"
        data-offset="100"
      />
    </section>
    <section class="s2 j" data-offset="0">
      <PrHoldOrNot
        img="/img/dc/chuncheon/bg-s2.jpg"
        title="Location"
        mobile-height="375"
      >
        <template v-slot:holdRight>
          <div
            class="dc-sample-s2-exp"
            data-p="0.4,1"
            data-px="-100,0"
            data-a="0,1"
          >
            <h3>이곳은 <br />강원도 춘천</h3>
            <div class="cover">
              <h4>
                데이터센터 <br />구축을 위한 첫걸음, <br />전력과 통신망 확보
              </h4>
              <h5>
                데이터센터 각 춘천은 반경 10km 안에 있는 변전소 두 곳에서 최대 40,000kW의 전력을 공급받습니다.
              </h5>
            </div>
          </div>
        </template>

        <div class="dc-sample-s2-exp">
          <div class="img">Location</div>
          <h3 class="q">이곳은 <br class="hidden-md-up" />강원도 춘천</h3>
          <div class="cover">
            <h4 class="q">
              데이터센터 <br />구축을 위한 첫걸음, <br />전력과 통신망 확보
            </h4>
            <p class="q">
              데이터센터 각 춘천은 반경 10km 안에 있는 변전소 두 곳에서 최대 40,000kW의 전력을 공급받습니다.
            </p>
          </div>
        </div>
      </PrHoldOrNot>
    </section>
    <section class="s3">
      <PrBlock class="v3 j">
        <img
          src="/img/dc/chuncheon/bg-s3-1.jpg"
          alt=""
          data-p="0.5,0.8"
          data-y="0,-10"
        />
        <img
          src="/img/dc/chuncheon/bg-s3-2.jpg"
          alt=""
          data-p="0.5,0.9"
          data-y="0,40"
        />
      </PrBlock>
      <div class="exp">
        <h4><TextBlock file="dc/chuncheon-data-t3" class="pre-line q" /></h4>
        <p class="q">
          춘천의 연평균 기온은 수도권 대비 평균 기온이 1~2C 낮아 1년 365일 중 자연 바람을 활용하여 데이터센터를 운영할 수 있는 기간이 길고, 이는 냉방 비용을 친환경적으로 절감하는 효과를 줍니다. 최근 한반도에서도 지진발생이 잦아지고 있지만, 춘천은 지난 수십년간 지진의 영향권이 가장 적었던 도시 중 하나입니다.
        </p>
      </div>
      <!-- <ul class="info">
        <li class="q">
          <h6>연평균 기온</h6>
          <h3 />
        </li>
        <li class="q">
          <h6>냉각 비용 절감</h6>
          <h3 />
        </li>
        <li class="q">
          <h6>지진 발생하지 않은 기간</h6>
          <h3 />
        </li>
      </ul> -->
    </section>
    <section class="s8 j">
      <PrSplit class="vis" img="/img/dc/chuncheon/bg-s9.jpg" title="Technology" bottom-free/>
      <div class="exp">
        <h4><TextBlock file="dc/chuncheon-data-t5" class="pre-line q" /></h4>
        <p class="q">
          데이터센터 각 춘천은 더 안전하고 정확한 기술력을 
          바탕으로 자연과 함께 만드는 에너지 효율을 목표로 
          합니다.
        </p>
      </div>
      <quick-link-item type="gray">
        <a class="" href="/tech/technology">Technology에서 <br />확인하기</a>
      </quick-link-item>
    </section>
    <section class="s4 j">
      <PrSplit
        class="v4"
        img="/img/dc/chuncheon/bg-s4.jpg"
        title="Architecture"
      />
      <div class="exp">
        <h3>자연과 안전의 <br/>어울림</h3>
        <p class="map"><q></q></p>
        <h4><TextBlock file="dc/chuncheon-data-t2" class="pre-line q" /></h4>
        <p class="q">
          데이터센터 각 춘천은 중앙의 한 동을 나머지 세 개 동이 둘러싸는 구조입니다. 
          서버를 여러 동에 분산해 안전성을 높이고, 데이터 증가 속도에 맞춰 증축이 쉬우며, 에너지 효율도 높일 수 있습니다.
        </p>
      </div>
      <video
        :src="`${videoBase}/chuncheon.mp4`"
        muted
        autoplay
        loop
        playsinline
        class="pic"
      />
      <div class="exp">
        <h4><TextBlock file="dc/chuncheon-data-t8" class="pre-line q" /></h4>
        <p class="q">
          지형에 따라 불어오는 바람을 이용해 서버의 열기를 식힐 수 있도록 V자 형으로 건물을 배치했습니다.
          바람과 닿는 면적이 충분하도록 건물 폭은 넓히되, 공기의 흐름이 원활하도록 건물을 V자 형태로 꺾어
          동과 동 사이의 간격을 확보했습니다.
        </p>
      </div>
    </section>
    <section class="s5">
      <PrSplit class="v5" type="type2" img="/img/dc/chuncheon/bg-s6.jpg" />
      <div class="exp">
        <h4><TextBlock file="dc/chuncheon-data-t9" class="pre-line q" /></h4>
        <p class="q">
          자연환경과 어우러지도록 장경각의 색을 입힌 루버는 
          건물 내부로 들어오는 햇빛을 차단하여 냉방 효과를 
          높입니다.
        </p>
      </div>
    </section>
    <section class="s6">
      <PrSplit class="v6 q" type="type3" img="/img/dc/chuncheon/bg-s7.jpg" />
      <div class="exp">
        <h4 class="q">자연과 어울리는 <br>계단식 저층 구조</h4>
        <p class="q">
          대지의 경사면을 따라 넓고 낮게 앉힌 계단식 저층 구조인 데이터센터 각 춘천은 자연과 어울리도록 설계됐습니다. 
          낮은 건축의 형태는 화재나 지진에도 비교적 안전하며 네트워크 구조도 더 간단하여 제어하기 쉽습니다.
        </p>
      </div>
    </section>
    <section class="s7">
      <PrSplit
        class="v7 q"
        type="type4"
        img="/img/dc/chuncheon/bg-s8.jpg"
        :alpha50="false"
      />
      <div class="exp">
        <h4><TextBlock file="dc/chuncheon-data-t10" class="q pre-line" /></h4>
        <p class="q">
          구봉산의 생태축이 끊어지지 않도록 건물 옥상의 절반이 넘는 면적에 나무와 풀을 심어 수풀을 가꿨습니다. 
          옥상의 녹지는 여름에는 뜨거운 태양열을 차단하고 겨울에는 내부의 열을 지켜 냉난방 전력 소비를 줄이고 열섬 현상을 막습니다.
        </p>
      </div>
    </section>
    <div class="feature j">
      <section class="s9 gallery">
        <PrSplit v-if="sect === 'sm'" class="v9" img="/img/dc/chuncheon/bg-gallery.jpg" title="GAK Chuncheon Gallery" overflowTitle=""/>
        <PrSplit v-else class="v9" img="/img/dc/chuncheon/bg-gallery-pc.jpg" title="GAK Chuncheon Gallery" overflowTitle=""/>
      </section>
      <SliderTumbs navigation="true">
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-01.jpg" />
          </div>
          <div class="txt">
            <p>전력 공급 안정성과 무중단 전원 공급을 고려한 이중화 전원 시스템으로 설계된 전기실</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-02.jpg" />
          </div>
          <div class="txt">
            <p>한전 정전에도 에너지저장 회전체와 비상엔진 가동으로 끊김없이 서버 전원을 공급하는 Dynamic UPS</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-03.jpg" />
          </div>
          <div class="txt">
            <p>UPS 후단의 백업장치로, 전원이 차단됐을 때 다른 예비 회선으로 자동 연결시켜 전원을 공급하는 장치인 STS</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-04.jpg" />
          </div>
          <div class="txt">
            <p>자연바람을 사용하여, 서버의 열을 냉각시키는 네이버 자체 개발 공조설비인 NAMU</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-05.jpg" />
          </div>
          <div class="txt">
            <p>안전하고 효율적인 IT 서비스를 공급할 수 있도록 설계된 데이터센터 각 서버실</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-06.jpg" />
          </div>
          <div class="txt">
            <p>태양과 바람 경로를 고려하여 건물의 냉방 효과를 높인 루버 (장경각 고유의 색상 적용)</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-07.jpg" />
          </div>
          <div class="txt">
            <p>에너지 절약과 효율을 고려하여 최적화 설계된 각 춘천의 기계실</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-08.jpg" />
          </div>
          <div class="txt">
            <p>서버 집적도를 향상시킨 자체 개발 네이버 전용 랙</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-09.jpg" />
          </div>
          <div class="txt">
            <p>일반 랙 보다 두 배에 달하는 용량인 랙당 11kW 전력 공급이 가능한 고전력 서버랙</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-10.jpg" />
          </div>
          <div class="txt">
            <p>데이터센터 온실가스 배출 절감을 위해 주차장 및 여유부지에 구축된 태양광발전설비</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-11.jpg" />
          </div>
          <div class="txt">
            <p>태양광에너지를 활용하여 운영되는 친환경 온실</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-12.jpg" />
          </div>
          <div class="txt">
            <p>직사광선을 피하고 건축물의 실내온습도를 유지해주기 위해 조성한 건축물 녹화</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/chuncheon/gallery-slide-13.jpg" />
          </div>
          <div class="txt">
            <p>최적화된 IT 인프라 제공을 위해 자체 개발된 모듈형 컨테이너 타입의 데이터센터, 스마트 서버팜</p>
          </div>
        </div>
      </SliderTumbs>
      <article class="bottom">
        <GridBase b50>
          <TextBlock file="dc/chuncheon-data-t7" class="q pre-line" />
          <!-- <p class="q">*궤(櫃) : 옷이나 물건을 넣는 네모난 통</p> -->
        </GridBase>
        <quick-link>
          <quick-link-item><router-link to="gak-global">GAK<br class="hidden-md-up" />Global</router-link></quick-link-item>
          <quick-link-item type="gray"><a class="launch" target="_blank" href="https://datacenter.ncloud.com/">GAK<br class="hidden-md-up" /> Chuncheon<br />Virtual tour</a></quick-link-item>
        </quick-link>
      </article>
    </div>
  </GridBase>
</template>

<script>
import GridBase from "@/views/components/GridBase";
import PrSplit from "@/views/components/PrSplit";
import TextBlock from "@/views/components/TextBlock";
import PrHoldOrNot from "@/views/components/PrHoldOrNot";
import PrBlock from "@/views/components/PrBlock";
import feature from "@/data/gak/chuncheonFeature";
import QuickLink from "@/views/components/QuickLink";
import QuickLinkItem from "@/views/components/QuickLinkItem";
import SliderTumbs from "@/views/components/SliderTumbs";
import { getOffsetLeft } from "@/utils";

export default {
  name: "gak-chuncheon",
  components: {
    SliderTumbs,
    QuickLinkItem,
    QuickLink,
    PrBlock,
    PrHoldOrNot,
    TextBlock,
    PrSplit,
    GridBase,
  },
  data() {
    return {
      f2Active: -1,
      f3Active: -1,
      feature,
      f1: feature[0],
      f2: feature[1],
      f3: feature[2],
    };
  },
  watch: {},
  computed: {
    chuncheonPopupStatus() {
      return this.$store.state.chuncheonPopup;
    },
  },
  methods: {
    showPopupF1(idx) {
      this.$store.commit("setChuncheonPopup", {
        type: "type-01",
        idx,
        info: this.f1,
      });
    },
    showPopupF2(idx) {
      this.$store.commit("setChuncheonPopup", {
        type: "type-02",
        idx,
        info: this.f2,
      });
    },
    resetF2(idx, el) {
      this.f2Active = idx;
      const right =
        getOffsetLeft(el) +
        +el.parentNode.style.transform.match(/(-?\d+)px/)[1] +
        el.offsetWidth;
      if (right > window.innerWidth) this.$refs.f2slide.next();
    },
    resetF3(idx) {
      if (this.sect === "sm" || this.sect === "md") {
        this.$store.commit("setChuncheonPopup", {
          type: "type-03",
          idx,
          info: this.f3,
        });
      } else {
        this.f3Active = this.f3Active === idx ? null : idx;
      }
    },
    closePopup() {
      this.$store.commit("setChuncheonPopup", null);
    },
    resize() {
      this.closePopup();
    },
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
};
</script>
